import { Grid, Paper, Typography } from "@material-ui/core";
import React from "react";
import SimpleDialogDemo from "../../../Modals/SimpleDialog";
import ParticipantesListResumen from "../ParticipantsLists/ParticipantesListResumen";

// Alto fijo para que todas las casillas midan lo mismo sin importar qué tan
// largo sea el nombre del producto.
const ALTURA_CAJA = 150;

function Estadistica({ etiqueta, valor, flex }) {
  return (
    <div style={{ textAlign: "center", flex: flex || 1, minWidth: 0 }}>
      <Typography variant="caption" style={{ color: "#666", display: "block" }}>
        {etiqueta}
      </Typography>
      <Typography
        variant="subtitle1"
        color="primary"
        style={{ fontWeight: "bold", fontSize: 15, overflowWrap: "break-word" }}
      >
        {valor}
      </Typography>
    </div>
  );
}

const DashboardExtraProducts = ({ jsonProducts, eventParticipants, eventSubEventsRegistry }) => {
  var Adicionales = [];
  for (var e in jsonProducts) {
    var nombreProducto = jsonProducts[e].nombreProducto;

    Adicionales.push(
      <Grid item xs={12} sm={6} key={e}>
        <Paper
          style={{
            padding: 16,
            margin: 5,
            backgroundColor: "#e0e0e0",
            height: ALTURA_CAJA,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant={"h6"}
            align="center"
            style={{ fontWeight: "bold", marginBottom: 8 }}
          >
            {nombreProducto}
          </Typography>

          <div style={{ display: "flex", flex: 1, alignItems: "center" }}>
            <Estadistica etiqueta="Ventas" valor={jsonProducts[e].sumaCompras} />
            <Estadistica etiqueta="Cantidad" valor={jsonProducts[e].sumaCantidades} />
            <Estadistica
              etiqueta="Ingresos"
              flex={1.4}
              valor={Intl.NumberFormat("es-MX", {
                style: "currency",
                currency: "MXN",
              }).format(jsonProducts[e].sumaIngresos)}
            />
            <div style={{ marginLeft: 8, flexShrink: 0 }}>
              <SimpleDialogDemo buttonText={"Ver Listado"} color="secondary">
                <ParticipantesListResumen
                  participantes={(jsonProducts[e].participantes || [])
                    .map((key) => eventParticipants[key])
                    .filter(Boolean)}
                  eventSubEventsRegistry={eventSubEventsRegistry}
                />
              </SimpleDialogDemo>
            </div>
          </div>
        </Paper>
      </Grid>
    );
  }

  return (
    <Paper style={{ padding: 10, margin: 5 }}>
      <Typography variant={"h2"} align="center">
        Productos Adicionales
      </Typography>

      <Grid container direction="row" justifyContent="space-around" alignItems="stretch">
        {Adicionales}
      </Grid>
    </Paper>
  );
};

export default DashboardExtraProducts;
